import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

export default function Copyright(props) {
  //console.debug("RTS Break Copyright");

  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://southwire.com/">
        Southwire
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}
